// extracted by mini-css-extract-plugin
export default {"details":"DiamondOtherDetails_details__SbTok","label":"DiamondOtherDetails_label__v-9cA","span":"DiamondOtherDetails_span__VmGrc","spanLink":"DiamondOtherDetails_spanLink__-zrk7"};